import type { QuestionProps } from '../eform.types'
import { stripWhiteBg } from '../EFormRenderer'

export default function InstructionBlock({ question }: QuestionProps) {
  const isScrollable = question.questionType === 23

  return (
    <div
      className={`prose prose-sm max-w-none text-slate-700 [&_*]:bg-transparent ${
        isScrollable ? 'max-h-72 overflow-y-auto rounded-lg border border-slate-200 p-4' : ''
      }`}
      dangerouslySetInnerHTML={{ __html: stripWhiteBg(question.questionContent) }}
    />
  )
}
